<template>
  <div class="tenant-dashboard-cla">
    <div class="chart-header-cla">
      <div class="header-item1-cla">
        <div>
          <span>{{ dateTime }}</span>
        </div>
        <div>
          <span>{{ weekday }}</span>
        </div>

        <div>
          <span>{{ time }}</span>
        </div>
      </div>
      <div class="header-item2-cla">
        <img
          class="SmartBDB-title-cla"
          src="@/assets/new/dashboard/Smart DBS.png"
        />
      </div>
      <div class="header-item3-cla">
        <div
          v-if="!isFullScreenFn()"
          class="fullscreen-cla"
          @click.stop="chartPage"
        ></div>
        <div
          v-if="isFullScreenFn()"
          class="nofullscreen-cla"
          @click.stop="chartPage"
        ></div>
      </div>
    </div>
    <div class="chart-content-cla">
      <div class="left-part-chart-cla">
        <div class="map-chart-box">
          <mapchar></mapchar>
        </div>
        <div class="bottom-bar-box">
          <div class="pie-char-box">
            <onlineDeviceChat></onlineDeviceChat>
          </div>
          <div class="bar-chart-box">
            <mapBarChar></mapBarChar>
          </div>
        </div>
      </div>
      <div class="right-part-chart-cla">
        <div style="padding-bottom: 10px" class="right-chart-box">
          <div>
            <deviceTypeChart></deviceTypeChart>
          </div>
        </div>
        <div style="padding-top: 10px" class="right-chart-box">
          <div>
            <newAddedTotal></newAddedTotal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import deviceTypeChart from './deviceTypeChart/deviceTypeChart'
import newAddedTotal from './newAddedTotal/newDevChar.vue'
import onlineDeviceChat from './onlineDeviceChat/onlineDeviceChat.vue'
// import mapchar from './mapchar/mapChar' // 世界地球
import mapchar from './mapchar/worldMap' // 世界地图
import mapBarChar from './mapBarChar/mapBarChar'
export default {
  data() {
    return {
      time: '',
      dateTime: '',
      weekday: '',
      interval: null,
      isMap: false,
      isDashboardPage: true
    }
  },
  components: {
    deviceTypeChart,
    newAddedTotal,
    onlineDeviceChat,
    mapchar,
    mapBarChar
  },
  created() {
    // map 全屏状态 esc事件
    window.addEventListener('resize', this.mapExitFull)
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getTime()
      this.getWeekDay()
      this.getDate()
    }, 500)
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    this.isDashboardPage = false
    window.removeEventListener('resize', this.mapExitFull)
  },
  methods: {
    mapExitFull() {
      if (this.isDashboardPage) {
        let _self = this
        if (!_self.isFullScreenFn()) {
          if (sessionStorage.getItem('loginName') === 'admin') {
            _self.$router.push('/tenantDashboard/dashboard')
          }
        }
      }
    },
    chartPage() {
      this.isFull = !this.isFullScreenFn()
      this.fullScreen(this.isFull)
      if (this.isFull) {
        this.$router.push('/chartPage')
      } else {
        this.$router.push('/tenantDashboard/dashboard')
      }
    },
    isFullScreenFn() {
      let isFull = !!(
        document.fullscreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen ||
        document.webkitFullScreen ||
        document.msFullScreen
      )

      if (isFull === undefined) {
        isFull = false
      }
      return isFull
      // return !!(
      //   document.fullscreen ||
      //   document.mozFullScreen ||
      //   document.webkitIsFullScreen ||
      //   document.webkitFullScreen ||
      //   document.msFullScreen
      // )
    },
    fullScreen(isFullScreen) {
      if (isFullScreen && !this.isFullScreenFn()) {
        var docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen()
        }
      } else if (this.isFullScreenFn()) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    getWeekDay() {
      var mydate = new Date()
      var myddy = mydate.getDay()
      var weekday = [
        this.$t('common.sunday'),
        this.$t('common.monday'),
        this.$t('common.tuesday'),
        this.$t('common.wednesday'),
        this.$t('common.thursday'),
        this.$t('common.friday'),
        this.$t('common.saturday')
      ]
      this.weekday = weekday[myddy]
    },
    getDate() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      this.dateTime = year + '-' + month + '-' + day
    },
    getTime() {
      var date = new Date()
      var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      this.time = hour + ':' + minute + ':' + second
    }
  }
}
</script>
<style scoped lang="less">
.tenant-dashboard-cla {
  height: 100vh;
  background-image: url('~~@/assets/new/dashboard/dashboardBg.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  .chart-header-cla {
    height: 53px;
    line-height: 53px;
    flex-shrink: 0;
    background-image: url('~~@/assets/new/dashboard/headBg.png');
    background-size: 100% 100%;
    display: flex;
    align-items: flex-end;
    .header-item {
      height: 37px;
    }
    .header-item1-cla {
      display: flex;
      .header-item;
      width: 33.5%;
      justify-content: space-around;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 26px;
      color: #21d0ce;
      text-align: right;
    }
    .header-item2-cla {
      .header-item;
      width: 33%;
      text-align: center;
      .SmartBDB-title-cla {
        position: relative;
        top: -8px;
        height: 33px;
      }
    }
    .header-item3-cla {
      .header-item;
      width: 33.5%;
      display: flex;
      justify-content: flex-end;
    }
  }

  .fullscreen-cla {
    width: 24px;
    height: 24px;
    margin-right: 20px;
    cursor: pointer;
    background-image: url('~~@/assets/new/dashboard/fullscreen.svg');
  }
  .nofullscreen-cla {
    width: 24px;
    height: 24px;
    margin-right: 20px;
    cursor: pointer;
    background-image: url('~~@/assets/new/dashboard/nofullscreen.svg');
  }
  .chart-content-cla {
    display: flex;
    flex: auto;
    padding: 18px;
    height: 100%;
    background-clip: content-box;
    .left-part-chart-cla {
      flex-grow: 1;
      background-clip: content-box;
      position: relative;
      padding-bottom: 239px;
      margin-right: 20px;
      .map-chart-box {
        height: 100%;
        width: 100%;
      }
      .bottom-bar-box {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 239px;
        display: flex;
        justify-content: stretch;
        .pie-char-box {
          height: 100%;
          flex-basis: 322px;
        }
        .bar-chart-box {
          margin-left: 20px;
          height: 100%;
          flex-grow: 1;
        }
      }
    }
    .right-part-chart-cla {
      flex-basis: 340px;
      height: 100%;
      .right-chart-box {
        height: 50%;
        box-sizing: border-box;
        background-clip: content-box;
        & > div {
          height: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/dashboard/dashboard.vue